<template>
  <div class="modal fade" id="taskCommentModal" tabindex="-1" aria-labelledby="taskCommentModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="taskCommentModalLabel">
            Podgląd komentarza
          </h5>
          <button id="show-task-comment-modal-close-btn" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body" v-if="comment && vehicleId">
          <div
            class="p-1 rounded mb-2"
            :style="`background-color: ${comment.backgroundColor ?? '#ffffff'}; color: ${comment.textColor ?? '#000000'};`">
            <h6>
              {{ comment.title }}
            </h6>
            <p v-html="handleNewLine(comment.content)"></p>
          </div>
          <div class="d-flex justify-content-between">
            <CommentEdit
              :key="comment.id"
              :comment="comment"
              style="float: left; text-align: center;"
            />
            <button :key="comment.id" class="btn btn-danger" @click="deleteComment(comment.id)">
              Usuń komentarz
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import emitter from '@/modules/events/emitter'
import CommentEdit from '@/components/CommentEdit.vue'

export default {
  name: 'ShowTaskCommentModal',
  components: { CommentEdit },
  data () {
    return {
      comment: null,
      vehicleId: null
    }
  },
  created () {
    emitter.on('taskCommentModalRequested', e => {
      this.comment = e.comment
      this.vehicleId = e.vehicleId
    })
  },
  methods: {
    handleNewLine (str) {
      return str.replace(/(?:\r\n|\r|\n)/g, '<br />')
    },

    deleteComment (id) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      axios.delete(process.env.VUE_APP_API_BASE_URL + 'Comment/' + id, config).then(() => {
        Swal.fire({
          title: 'Komentarz usunięty',
          text: 'Komentarz został usunięty',
          icon: 'success',
          confirmButtonText: 'OK'
        })

        document.getElementById('show-task-comment-modal-close-btn').click()

        emitter.emit('trioCommentModified')
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>
